import React, { Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import cloneDeep from "lodash/cloneDeep";
import { AppSettings } from "../../constants";
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import HomeownerSidebar from "./Sidebar-Homeowner";

let ps;
class Sidebar extends Component {
  static propTypes = {
    location: PropTypes.object,
    groupMenu: PropTypes.array,
    items: PropTypes.array,
    title: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.sidebarRef = React.createRef(); // create the ref
    this.ps = null;

    this.state = {
      isWindows: navigator.platform.indexOf("Win") > -1,
      width: window.innerWidth,
      groupMenu: this.getGroupMenu(),
    };
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));

    if (this.state.isWindows && this.sidebarRef.current) {
      this.ps = new PerfectScrollbar(this.sidebarRef.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }

  componentDidUpdate() {
    if (this.state.isWindows && this.ps) {
      setTimeout(() => {
        this.ps.update();
      }, 350);
    }
  }

  componentWillUnmount() {
    if (this.state.isWindows && this.ps) {
      this.ps.destroy();
    }
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    // return this.props.location.pathname === routeName ? 'active' : '';
    let pathName = this.props.location.pathname.split("/")[1];
    let routeNamePath = routeName.split("/")[1];

    if (AppSettings.clientTypeValue === "Subcontractor") {
      if (pathName === "request-for-services") {
        pathName = "work-order-list";
      }
      if (routeNamePath === "request-for-services") {
        routeNamePath = "work-order-list";
      }
    }

    return pathName === routeNamePath ? "active" : "";
  }

  // if the windows width changes CSS has to make some changes
  // this functions tell react what width is the window
  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  getGroupMenu = () => {
    let groups = cloneDeep(this.props.groupMenu);
console.log("🚀 ~ getGroupMenu ~ groups:", groups)
console.log("🚀 ~ getGroupMenu ~ this.props.items:", this.props.items)
    this.props.items.map((element) => {
      if (element.menu.group) {
        if (groups.some((x) => x.group === element.menu.group)) {
          const groupItem = groups.find((y) => y.group === element.menu.group);
          if (!groupItem.items) {
            groupItem.items = [];
          }
          groupItem.items.push(element);
        }
      }
    });
    return groups;
  };

  toggleCollapse = (event, name) => {
    event.preventDefault();
    let group = this.state[name];
    this.setState({ [name]: !group });
  };

  checkGroupActive = (name) => {
    const { groupMenu } = this.state;
    let menuItem = groupMenu.find((x) => x.group === name).items;
    let menuFilter;
    if (menuItem && menuItem.length) {
      menuFilter = menuItem.filter((item) => {
        return this.activeRoute(item.path);
      });
    }
    if (menuFilter && menuFilter.length) {
      return "active";
    }
    return "";
  };

  renderGroupMenu = (groups) => {
    let groupMenu = [];
    for (let i in groups) {
      if (groups.hasOwnProperty(i)) {
        groupMenu.push(
          <li
            key={i}
            className={`group-menu-parent ${this.checkGroupActive(i)} ${
              groups[i].className ? groups[i].className : ""
            }`}
          >
            <a onClick={(e) => this.toggleCollapse(e, i)}>
              <i className={groups[i].icon} />
              <p>
                {groups[i].name}
                <b className={this.state[i] ? "caret" : "caret rotate-270"} />
              </p>
            </a>
            <Collapse in={this.state[i]}>
              <ul className="nav">
                {groups[i].subGroup
                  ? groups[i].subGroup.map((element, index) => {
                      const list = groups[i].items.filter(
                        (x) => x.menu.subGroup === element.key
                      );
                      return (
                        <React.Fragment key={index}>
                          <div className="sidebar__sub-group__label">
                            {element.name}
                          </div>
                          {this.renderMenuItems(list)}
                        </React.Fragment>
                      );
                    })
                  : this.renderMenuItems(groups[i].items)}
                {/*{this.renderMenuItems(groups[i].items)}*/}
              </ul>
            </Collapse>
          </li>
        );
      }
    }
    return groupMenu;
  };

  getSidebarTranslateName = (originalName) => {
    if (!window.customTerms) return originalName;
    
    // We get string names like 'Requests for service', 'Projects', 'Lots', 'Blue Tape', etc.
    // Or it might be a React Object (from the <Translate> component).
    let textStr = '';
    if (typeof originalName === 'string') {
      textStr = originalName.toLowerCase().trim();
    } else if (originalName && originalName.props && originalName.props.translateKey) {
      textStr = originalName.props.translateKey.toLowerCase().trim();
    }

    const capitalize = (str) => {
      if (!str || typeof str !== 'string') return str;
      return str.split(' ').map(word => word ? word.charAt(0).toUpperCase() + word.slice(1) : '').join(' ');
    };
    
    if (textStr === 'project' || textStr === 'projects') {
       let term = window.customTerms.project ? window.customTerms.project + 's' : originalName;
       return capitalize(term);
    }
    if (textStr === 'lot' || textStr === 'lots') {
       let term = window.customTerms.lot ? window.customTerms.lot + 's' : originalName;
       return capitalize(term);
    }
    if (textStr === 'homeowner' || textStr === 'homeowners') {
       let term = window.customTerms.homeowner ? window.customTerms.homeowner + 's' : originalName;
       return capitalize(term);
    }
    if (textStr === 'punch list' || textStr === 'punch lists' || textStr === 'blue tape') {
       let term = window.customTerms.punchlist ? window.customTerms.punchlist : originalName;
       return capitalize(term);
    }
    
    return originalName;
  };

  renderMenuItems = (items) => {
    if (!items) {
      return null;
    }
    return items.map((route, key) => {
      let displayName = this.getSidebarTranslateName(route.menu.name);

      return (
        <li
          className={`${this.activeRoute(route.path)} ${
            route.menu.className ? route.menu.className : ""
          }`}
          key={key}
        >
          <NavLink
            exact
            to={{
              pathname: route.path,
              search:
                this.props.location.pathname === route.path
                  ? this.props.location.search
                  : null,
            }}
            activeClassName="active"
            className="nav-link"
          >
            <i
              className={`${
                route.menu.icons ? route.menu.icons : route.menu.iconClass
              } sidebar-mini`}
            />
            {/* {console.log('SIDEBAR ITEM RENDER =>', route.menu.name)} */}
            <p>{displayName}</p>
          </NavLink>
        </li>
      );
    });
  };

  renderItems = (groupMenuItems, groupMenu) => {
    return [...groupMenuItems, ...groupMenu]
      .sort((a, b) => {
        if (!a.menu.order) {
          return -1;
        }
        if (!b.menu.order) {
          return 1;
        }
        return a.menu.order - b.menu.order;
      })
      .map((item) => {
        if (item.menu.isGroup) {
          return this.renderGroupMenu({ [item.group]: { ...item } });
        } else {
          return this.renderMenuItems([item]);
        }
      });
  };

  render() {
    // get route without group, or it's group doesn't exist in groupMenu
    const groupMenuItems = this.props.items.filter((route) => {
      return !(
        route.menu.group &&
        this.props.groupMenu.some((x) => x.group === route.menu.group)
      );
    });
    // console.log("🚀 ~ groupMenuItems:", groupMenuItems);

    const { groupMenu } = this.state;
    // console.log("🚀 ~ this:", this);

    return AppSettings.clientTypeValue === "Homeowner" ? (
      <HomeownerSidebar parent={this} location={this.props.location} />
    ) : (
      <div className="sidebar">
        <div className="sidebar-background" />
        {/*   <div className='logo'>
          <a
            href='/'
            className='simple-text logo-mini'
          >
            <div className='logo-img'>
              <img src={this.props.logo} alt='logo' />
            </div>
          </a>
          <a
            href='/'
            className='simple-text logo-normal'
          >
            {this.props.displayName}
          </a>
        </div>
    */}

        <div className="sidebar-wrapper" ref={this.sidebarRef}>
          {/* <div className='user'>
            <div className='photo'>
              <img src={avatar} alt='Avatar' />
            </div>
            <div className='info'>
              <a
                onClick={() =>
                  this.setState({ openAvatar: !this.state.openAvatar })
                }
              >
                <span>
                  Tania Andrew
                  <b
                    className={
                      this.state.openAvatar ? 'caret rotate-180' : 'caret'
                    }
                  />
                </span>
              </a>
            </div>
          </div> */}

          <ul className="nav">
            {/* If we are on responsive, we want both links from navbar and sidebar
                            to appear in sidebar, so we render here HeaderLinks */}
            {/* {this.state.width <= 992 ? <HeaderLinks /> : null} */}
            {/*
                            here we render the links in the sidebar
                            if the link is simple, we make a simple link, if not,
                            we have to create a collapsible group,
                            with the speciffic parent button and with it's children which are the links
                        */}
            {this.renderItems(groupMenuItems, groupMenu)}
            {/* {this.renderMenuItems(groupMenuItems)} */}
            {/* {this.renderGroupMenu(groupMenu)} */}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js